enum UploadFileStatus {
  // defined on the server
  IN_PROGRESS = "in_progress",
  COMPLETE = "complete",
  FAILED = "failed",
  // defined only locally
  WAITING = "waiting",
  PENDING = "pending",
  RETRY = "retry",
}

export default UploadFileStatus;
